import React, { useEffect } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import { useSelector } from "react-redux";
import Masterlist from "../pages/Leasing/Masterlist";
import LandlordRep from "../pages/Leasing/LandlordRep";
import TenantRep from "../pages/Leasing/TenantRep";
import Pipeline from "../pages/Leasing/Pipeline";
import { useSearchParams } from "react-router-dom";
import {
  FaPlus,
  FaBuilding,
  FaUserTie,
  FaHandshake,
  FaChartLine,
} from "react-icons/fa";

function Leasing() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.userObject);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeLink = searchParams.get("link");

  const links = [
    { name: "Masterlist", icon: <FaBuilding /> },
    { name: "Tenant Representation", icon: <FaUserTie /> },
    { name: "Landlord Representation", icon: <FaHandshake /> },
    { name: "Pipeline", icon: <FaChartLine /> },
  ];

  const handleNewBuilding = () => {
    navigate("/leasing/newbuilding");
  };

  const authorizedList = ["admin", "approver"];

  if (
    !currentUser.roles.some((role) => authorizedList.includes(role)) &&
    currentUser.department !== "Commercial Leasing"
  ) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-white p-8 text-center">
        <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md border border-gray-100">
          <FaBuilding className="text-[#002368] text-5xl mx-auto mb-4 opacity-30" />
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Access Denied
          </h1>
          <p className="text-gray-700 mb-2">
            Sorry, you are not authorized to view this page.
          </p>
          <p className="text-gray-700 mb-6">
            Only Commercial Leasing Department or Approvers can view
          </p>
          <Button
            label="Return to Home"
            variant="primary"
            onClick={() => navigate("/")}
          />
        </div>
      </div>
    );
  }

  const handleActiveLink = (link) => {
    navigate(`/leasing/${link.toLowerCase().replace(" ", "")}?link=${link}`);
  };

  return (
    <div className="leasing flex flex-col p-6 bg-white min-h-screen">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold text-gray-800">
          Commercial Leasing Management
        </h1>
        <Button
          label={
            <div className="flex items-center gap-2">
              <FaPlus /> Add New Building
            </div>
          }
          variant="primary"
          onClick={handleNewBuilding}
        />
      </div>

      <div className="bg-white border border-gray-100 p-6 rounded-xl shadow-sm mb-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-center gap-4 flex-wrap">
            {links.map((link) => (
              <div
                className={
                  activeLink === link.name
                    ? "flex items-center gap-2 px-5 py-2.5 rounded-xl cursor-pointer bg-[#002368] text-white font-medium transition-all duration-300 shadow-md"
                    : "flex items-center gap-2 px-5 py-2.5 rounded-xl cursor-pointer bg-white border border-gray-200 text-gray-700 hover:bg-[#ff5003] hover:text-white hover:border-[#ff5003] font-medium transition-all duration-300"
                }
                key={link.name}
                onClick={() => handleActiveLink(link.name)}
              >
                {link.icon} {link.name}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-6">
        {activeLink === "Masterlist" ? <Masterlist /> : null}
        {activeLink === "Landlord Representation" ? <LandlordRep /> : null}
        {activeLink === "Tenant Representation" ? <TenantRep /> : null}
        {activeLink === "Pipeline" ? <Pipeline /> : null}
      </div>
    </div>
  );
}

export default Leasing;
